import React from "react";

import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import {
	InformationRight,
	InformationRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";
import { ChangeEvent } from "utils/history/Event";
import { SelectField } from "../FieldService";
import SelectAttachment from "./SelectAttachment";

export type SelectInputProps = {
	field: SelectField;
	editable: boolean;
	rights: InformationRights;

	onChange: (event: ChangeEvent, valid: boolean) => void;
};

const SelectInput: React.FC<SelectInputProps> = (props: SelectInputProps) => {
	const selectedOption = props.field.options.find(
		option => option.value === props.field.value
	);

	function isValid(value: string): boolean {
		return props.field.required
			? props.field.options.some(option => option.value === value)
			: true;
	}

	function onChange(newValue: string): void {
		const change = new ChangeEvent("/value", props.field.value, newValue);
		props.onChange(change, isValid(newValue));
	}

	return (
		<Grid
			item
			container
			xs={12}
			md={6}
			columnSpacing={2}
			alignItems="center">
			<Grid item xs={12} sm={6}>
				<Typography variant="subtitle2" sx={{ wordWrap: "break-word" }}>
					{props.field.name}
					{props.field.required && " *"}
				</Typography>
			</Grid>
			<Grid item xs={12} sm={6}>
				{props.editable &&
				props.rights[props.field.uuid][InformationRight.WRITE] ? (
					<TextField
						id={props.field.name}
						select
						fullWidth
						required={props.field.required}
						error={!isValid(props.field.value)}
						value={props.field.value ?? ""}
						onChange={event => onChange(event.target.value)}
						variant="standard">
						<MenuItem value="">
							<p style={{ margin: 12 }} />
						</MenuItem>
						{props.field.options?.map((option, index) => (
							<MenuItem key={index} value={option.value}>
								{option.value}
							</MenuItem>
						))}
					</TextField>
				) : (
					<Typography variant="body2" sx={{ wordWrap: "break-word" }}>
						{props.field.value}
					</Typography>
				)}
			</Grid>
			<Grid item container direction="column">
				{selectedOption?.attachments.map((attachment, index) => (
					<Grid item key={`${attachment}-${index}`}>
						<SelectAttachment id={attachment} />
					</Grid>
				))}
			</Grid>
		</Grid>
	);
};

export default SelectInput;
